<template>
  <ca-modal
    ref="modal"
    title="Tipos de Entendimentos de contagem de dias para mensalistas">
    <template slot="body">
      <div>
        <ca-row>
          <ca-col>
            <ca-heading text="Misto Dias Normais e Extraordinários" size="extra-small" />
            <p>
              Nesse modelo a plataforma irá considerar sempre 30 dias para meses normais,
              e irá considerar a quantidade de dias no mês em casos extraordinários, ou seja,
              quando há admissão, férias, afastamento ou rescisão no peŕiodo.
              Esse é o modelo indicado pela Consultoria.
            </p>
          </ca-col>
        </ca-row>
        <ca-row>
          <ca-col>
            <ca-heading text="Sempre Comercial" size="extra-small" />
            <p>
              Nesse modelo, a plataforma irá sempre considerar 30 dias no mês.
            </p>
          </ca-col>
        </ca-row>
        <ca-row>
          <ca-col>
            <ca-heading text="Sempre número de dias do Mês" size="extra-small" />
            <p>
              Nesse modelo, a plataforma irá sempre considerar a quantidade real de dias no mês
              e o valor do dia trabalhado vai variar de acordo com a quantidade de dias no mês.
              Por exemplo: no mês de Fevereiro o salário dia será salário mês/28.
            </p>
          </ca-col>
        </ca-row>
      </div>
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="$refs.modal.close()">
          Fechar
        </ca-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
export default {
  name: 'ReferenceDaysCountingModal',
};
</script>
